import React, { FC } from 'react'

import YoutubeIcon from '../../../public/static/icons/youtube-white.svg'

import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import { getPropByCode } from '../../../lib/gql'
import css from './JournalYoutube.module.scss'
import { journalYoutubeItems_elements_nodes } from '../../../__generated__/journalYoutubeItems'
import cx from 'classnames'
import Image from '../../common/Image/Image'
import NImage from 'next/image'

const JournalYoutube: FC<{ items: journalYoutubeItems_elements_nodes[] }> = ({
  items,
}) => {
  if (items?.length < 1) {
    return null
  }

  return (
    <section className={css.wrapper}>
      <MaxWidth>
        <p className={css.heading}>
          <a
            href="https://www.youtube.com/channel/UCgjoM6EpXw1AhZ1z19ot0og"
            target="_blank"
            rel="noreferrer"
            className={css.link}
          >
            <YoutubeIcon />
          </a>
          <span>Мы на YouTube</span>
        </p>
        <ul className={css.posts}>
          {items?.map((item) => {
            const link = getPropByCode(item.propertyValues, 'YOUTUBE')

            if (!link) {
              return null
            }

            return (
              <li key={item.id}>
                <a
                  href={link}
                  className={css.post}
                  target="_blank"
                  rel="noreferrer"
                >
                  <figure className={cx(css.cover)}>
                    {item.previewPicture?.url ? (
                      <Image
                        src={item.previewPicture?.url}
                        layout="responsive"
                        width={400}
                        height={220}
                        sizes="400w"
                        loading="eager"
                      />
                    ) : (
                      <NImage
                        src="/static/images/product-no-image.jpg"
                        alt={item.name}
                        className="cover"
                        layout="responsive"
                        width={400}
                        height={220}
                        loading="eager"
                      />
                    )}
                  </figure>
                  <p className={css.yt}>Youtube</p>
                  <p className={css.title}>{item.name}</p>
                </a>
              </li>
            )
          })}
        </ul>
      </MaxWidth>
    </section>
  )
}

export default JournalYoutube
